export default __webpack_public_path__ + "static/media/guest.03a0c317.png";